import request from 'utils/request';

const PREFIX = '/api/aff/payment/app/';

export const AffPaymentAppAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  OPERATION_AUDIT: PREFIX + 'operation/audit',
  FINANCE_AUDIT: PREFIX + 'finance/audit',
  PREVIEW: PREFIX + 'preview',
  DETAIL: PREFIX + 'detail/',
  MERGE_INFO: PREFIX + 'merge-info/',
  PAYMENT: PREFIX + 'finance/payment',
  INVOICE_UPLOAD: PREFIX + 'invoice/upload',
};

export function getAffPaymentAppList(data) {
  return request({
    url: AffPaymentAppAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAffPaymentApp(data) {
  return request({
    url: AffPaymentAppAPI.ADD,
    method: 'post',
    data,
  });
}

export function operationAuditAffPaymentAppStatus(data) {
  return request({
    url: AffPaymentAppAPI.OPERATION_AUDIT,
    method: 'post',
    data,
  });
}

export function getAffPaymentAppPreviewData(data) {
  return request({
    url: AffPaymentAppAPI.PREVIEW,
    method: 'post',
    data,
  });
}

export function financePayment(data) {
  return request({
    url: AffPaymentAppAPI.PAYMENT,
    method: 'post',
    data,
  });
}

export function getAffPaymentDetailById(id) {
  return request({
    url: AffPaymentAppAPI.DETAIL + id,
    method: 'get',
  });
}

export function getAffPaymentDetailByNumber(number) {
  return request({
    url: AffPaymentAppAPI.MERGE_INFO + number,
    method: 'get',
  });
}
